// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'

import ErrorMessage from '@ttn-lw/lib/components/error-message'

import PropTypes from '@ttn-lw/lib/prop-types'

import { eventMessages } from '@console/lib/events/definitions'

import style from '../previews.styl'

const SyntheticErrorEventPreview = React.memo(({ event }) => (
  <ErrorMessage
    className={style.plainText}
    content={eventMessages[`${event.name}:preview`]}
    withRootCause
  />
))

SyntheticErrorEventPreview.propTypes = {
  event: PropTypes.event.isRequired,
}

export default SyntheticErrorEventPreview
